// Preview fixtures only. Never used as a fallback for a failed real API request.
export const demoAccounts = {
    '104287': {
        pin: 104287, name: 'Александр Иванов', phone: '9991234567', balance: 1250, telegram_id: 123,
        points: {
            'Дом · ул. Лесная, 12': {accounts: {
                'home': {disable: false, IP: '10.24.18.102', tarif: {name: 'Домашний 500', abon: 750}, speed_lim: 500000, speed_lim_actual: 500000, trcvd: 184 * 1073741824, tsent: 26 * 1073741824,
                    services: {'15': {name: 'Доступ в интернет', param: 500000, on_cost: 750}, '20': {name: 'Статический IP', param: 'Подключён', on_cost: 100}}},
                'tv': {disable: false, IP: '—', tarif: {name: 'Интерактивное ТВ', abon: 200}, services: {}}},
            },
            'Дача · СНТ Берёзки, 8': {accounts: {'country': {disable: true, IP: '10.25.12.81', tarif: {name: 'Загородный 100', abon: 450}, speed_lim: 100000, speed_lim_actual: 100000, trcvd: 0, tsent: 0, services: {}}}},
        },
    },
    '108562': {pin: 108562, name: 'Александр Иванов', phone: '9991234567', balance: 320, telegram_id: null,
        points: {'Офис · ул. Мира, 5': {accounts: {'office': {disable: false, IP: '10.32.8.10', tarif: {name: 'Бизнес 300', abon: 1200}, speed_lim: 300000, speed_lim_actual: 300000, trcvd: 75 * 1073741824, tsent: 12 * 1073741824, services: {}}}}}},
};
export const demoTransactions = [
    {id: 104287, date: '2026-10-14T12:30:00+03:00', comment: 'Пополнение через СБП', sum: 1500},
    {id: 108562, date: '2026-10-01T00:00:00+03:00', comment: 'Пополнение через СБП', sum: 750},
    {id: 104287, date: '2026-09-28T18:45:00+03:00', comment: 'Пополнение через СБП', sum: 1000},
    {id: 108562, date: '2026-09-01T00:00:00+03:00', comment: 'Пополнение через СБП', sum: 750},
];

export const demoStories = [
    {id: 'demo-1', name: 'Ваш интернет — всегда рядом', viewed: false},
    {id: 'demo-2', name: 'Всё об оплате через СБП', viewed: false},
    {id: 'demo-3', name: 'Больше возможностей с CLN', viewed: true},
    {id: 'demo-4', name: 'Как улучшить домашний Wi-Fi', viewed: false},
];
